import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { updateRelativeAnalysis as updateRelativeAnalysisAPI} from 'services/apiRelativeCompAnalysis';

const useUpdateRelCompAnalaysisData = () => {
  const queryClient = useQueryClient();
  const {isPending,isSuccess,isError,mutate:updateRelativeAnalysis } = useMutation({
    mutationFn: updateRelativeAnalysisAPI,
    onSuccess:(data) =>{
        queryClient.setQueryData(['updatedRelCompAnlData'],data)
        toast.success('Saved')
        queryClient.invalidateQueries({queryKey:['relCompAnalData']})
        
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return {isPending, isSuccess, isError, updateRelativeAnalysis}
}

export default useUpdateRelCompAnalaysisData